import { config } from "./config";

export const clientLogoDescriptions = {
  "visit-health": "Fitcoin Store",
};

export const CSS_FILES = {
  default: "/styles/main.css",
  lazypay: "/styles/lazypay.css",
  "lazypay-mock": "/styles/lazypay.css",
  "mock-niyo": "/styles/mobikwik.css",
};

export function getCSSFile(clientIdPrefix: string): string {
  if (clientIdPrefix in CSS_FILES) {
    return CSS_FILES[clientIdPrefix as keyof typeof CSS_FILES];
  }

  return CSS_FILES.default;
}

export const FONTS = {
  default: [
    "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Krona+One&display=swap",
  ],
  rnr: ["https://fonts.googleapis.com/css2?family=Sacramento&display=swap"],
  sdk: [
    {
      "mock-niyo":
        "https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap",
    },
  ],
};

export const BRAND_L2_SUMMARY_DISCOUNT_LABEL = {
  default: "Hubble discount",
  lazypay: "Lazypay discount",
  "lazypay-mock": "Lazypay discount",
};

export function getBrandL2SummaryLabel(clientIdPrefix: string): string {
  if (clientIdPrefix in BRAND_L2_SUMMARY_DISCOUNT_LABEL) {
    return BRAND_L2_SUMMARY_DISCOUNT_LABEL[
      clientIdPrefix as keyof typeof BRAND_L2_SUMMARY_DISCOUNT_LABEL
    ];
  }

  return BRAND_L2_SUMMARY_DISCOUNT_LABEL.default;
}

type ClientIdConfig = {
  axisClientId: string;
  tdClientId: string;
  bajajClientId: string;
  darkThemeClients: string[];
};

const CLIENT_ID_CONFIGS: Record<string, ClientIdConfig> = {
  prod: {
    axisClientId: "axisbank-llE1XBk0",
    tdClientId: "tata-digital-HmS62avt",
    bajajClientId: "bajajfinserv-CyyetFBG",
    darkThemeClients: [
      "axisbank-llE1XBk0",
      "tata-digital-HmS62avt",
      "bajajfinserv-CyyetFBG",
    ],
  },
  nonProd: {
    axisClientId: "acme-code-3241c2c1",
    tdClientId: "tata-digital-23gvn314",
    bajajClientId: "bajaj-code-Bp3sxUCw",
    darkThemeClients: [
      "tata-digital-23gvn314",
      "acme-code-3241c2c1",
      "bajaj-code-Bp3sxUCw",
    ],
  },
};

export const clientIdConfig =
  config.env === "Prod" ? CLIENT_ID_CONFIGS.prod : CLIENT_ID_CONFIGS.nonProd;

export function isDarkThemeClient(clientId: string): boolean {
  return clientIdConfig.darkThemeClients.includes(clientId);
}

export function showHowItWorksForCodeBasedPortal(clientId?: string): boolean {
  return (
    clientId === clientIdConfig.axisClientId ||
    clientId === clientIdConfig.bajajClientId
  );
}

export function showCoinsPillOnHome(clientId: string): boolean {
  return (
    clientId === clientIdConfig.axisClientId ||
    clientId === clientIdConfig.bajajClientId
  );
}

export function getLoginPageIntroText(clientId?: string): string {
  if (clientId === clientIdConfig.axisClientId) {
    return "👋 Welcome to Axis rewards portal";
  } else if (clientId === clientIdConfig.tdClientId) {
    return "👋 Welcome to Tata Digital rewards portal";
  }

  return "👋 Welcome";
}

export function getPartnerPortalTncUrl(clientId?: string): string {
  if (clientId === clientIdConfig.axisClientId) {
    return "https://www.myhubble.money/axisbank/terms-and-conditions";
  } else if (clientId === clientIdConfig.tdClientId) {
    return "https://www.myhubble.money/tata-neu/terms-and-conditions";
  }

  return "https://www.myhubble.money/terms-and-conditions";
}
